module.exports = __webpack_public_path__ + "static/media/singleQuote.7ccee9f2.svg";